import React, { useContext } from 'react';

import { Context } from '@store/store';
import ShowSettingsDropdownIconOnOpened from '@icons/show-settings-dropdown-icon-on-opened';
import ShowSettingsDropdownIcon from '@icons/show-settings-dropdown-icon';

import { StyledShowSettingsDropdownButton } from './show-settings-dropdown-button.styles';

const ShowSettingsDropdownButton = ({ isMobile }) => {
  const [state, dispatch] = useContext(Context);
  return (
    <React.Fragment>
      <StyledShowSettingsDropdownButton
        onClick={() => dispatch({ type: 'TOGGLE_SETTINGS_DROPDOWN' })}
        data-ignore-click-outside="dropdown"
        title="Настройки чтения: режим страниц, темы и переход на старую Читалку"
      >
        {state.isSettingsDropdownOpened ? (
          <ShowSettingsDropdownIconOnOpened
            width={isMobile ? 20 : 28}
            height={isMobile ? 20 : 28}
          />
        ) : (
          <ShowSettingsDropdownIcon
            width={isMobile ? 20 : 28}
            height={isMobile ? 20 : 28}
          />
        )}
      </StyledShowSettingsDropdownButton>
    </React.Fragment>
  );
};

export default ShowSettingsDropdownButton;
